export default "__VITE_ASSET__F0XKBezQ__"